import { Component } from '@angular/core';

import { pedidoNaoConfirmado } from '../../pedido-status';

@Component({
    selector: 'sgt-pedido-status-badge-nao-confirmado',
    templateUrl: './pedido-status-badge-nao-confirmado.component.html',
    styleUrls: ['./pedido-status-badge-nao-confirmado.component.less']
})
export class PedidoStatusBadgeNaoConfirmadoComponent {
    status = pedidoNaoConfirmado;
}
